import { render, staticRenderFns } from "./svgOrIcon.vue?vue&type=template&id=11f185b5&scoped=true"
import script from "./svgOrIcon.vue?vue&type=script&lang=js"
export * from "./svgOrIcon.vue?vue&type=script&lang=js"
import style0 from "./svgOrIcon.vue?vue&type=style&index=0&id=11f185b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f185b5",
  null
  
)

export default component.exports